import DashboardLayout from "components/DashboardLayout";
import Dashboard from "pages/Dashboard";
import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "constants/routes";
import { RedirectIfAuthed, RequireAuth } from "./RequireAuth";

const Login = lazy(() => import("pages/Login"));
const ForgotPassword = lazy(() => import("pages/ForgotPassword"));
const ResetPassword = lazy(() => import("pages/ResetPassword"));

// Auth routes
const Users = lazy(() => import("pages/Users"));
const Transactions = lazy(() => import("pages/Transactions"));
// Charity disabled for now
// const Charity = lazy(() => import("pages/Charity"));
const ExchangeRates = lazy(() => import("pages/ExchangeRates"));
const Beneficiaries = lazy(() => import("pages/Beneficiaries"));
const DepositTransactions = lazy(() => import("pages/DepositTransactions"));
const TransferTransactions = lazy(() => import("pages/TransferTransactions"));
// const ViewDonors = lazy(() => import("pages/Charity/ViewDonors"));
// Compliance disabled for now
// const Sanctions = lazy(() => import("pages/Sanction"));
const Currency = lazy(() => import("pages/Currency"));
const Profile = lazy(() => import("pages/Profile"));
const AdminUsers = lazy(() => import("pages/AdminUsers"));
const Audit = lazy(() => import("pages/Audit"));
const Businesses = lazy(() => import("pages/Businesses/Businesses"));

const RouteWrapper = (children: React.ReactNode | null) => (
  <Suspense fallback={<p>Loading...</p>}>{children}</Suspense>
);

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={ROUTES.MAIN.path}
          element={<RequireAuth>{RouteWrapper(<DashboardLayout />)}</RequireAuth>}
        >
          <Route path={ROUTES.DASHBOARD.path} element={RouteWrapper(<Dashboard />)} />
          <Route path={ROUTES.USERS.path} element={RouteWrapper(<Users />)} />
          <Route
            path={ROUTES.TRANSACTIONS.path}
            element={RouteWrapper(<Transactions />)}
          />
          {/* Charity disabled for now
          <Route path={ROUTES.CHARITY.path} element={RouteWrapper(<Charity />)} />
          */}
          <Route
            path={ROUTES.DEPOSITS.path}
            element={RouteWrapper(<DepositTransactions />)}
          />
          <Route
            path={ROUTES.TRANSFERS.path}
            element={RouteWrapper(<TransferTransactions />)}
          />
          {/* Charity disabled for now
          <Route
            path={ROUTES.VIEW_DONORS.path}
            element={RouteWrapper(<ViewDonors />)}
          />
          */}

          <Route path={ROUTES.PROFILE.path} element={RouteWrapper(<Profile />)} />

          <Route
            path={ROUTES.ADMIN_USERS.path}
            element={RouteWrapper(<AdminUsers />)}
          />

          <Route
            path={ROUTES.BUSINESSES.path}
            element={RouteWrapper(<Businesses />)}
          />

          <Route path={ROUTES.AUDIT_TRAIL.path} element={RouteWrapper(<Audit />)} />

          {/* Compliance disabled for now
          <Route
            path={ROUTES.FLAGGED_USERS.path}
            element={RouteWrapper(<Sanctions />)}
          />
          */}
          <Route
            path={ROUTES.EXCHANGE_RATES.path}
            element={RouteWrapper(<ExchangeRates />)}
          />
          <Route
            path={ROUTES.BENEFICIARIES.path}
            element={RouteWrapper(<Beneficiaries />)}
          />
          <Route path={ROUTES.CURRENCIES.path} element={RouteWrapper(<Currency />)} />
        </Route>

        <Route path={ROUTES.AUTH.path}>
          <Route
            path={ROUTES.LOGIN.path}
            element={<RedirectIfAuthed>{RouteWrapper(<Login />)}</RedirectIfAuthed>}
          />

          <Route path={ROUTES.VERIFY_2FA.path} element={<Navigate replace to={ROUTES.LOGIN.path} />} />
          <Route path={ROUTES.ENABLE_2FA.path} element={<RequireAuth><Navigate replace to={`${ROUTES.PROFILE.path}?tab=2fa`} /></RequireAuth>} />

          <Route
            path={ROUTES.FORGOT_PASSWORD.path}
            element={RouteWrapper(<ForgotPassword />)}
          />

          <Route
            path={ROUTES.RESET_PASSWORD.path}
            element={RouteWrapper(<ResetPassword />)}
          />
        </Route>

        <Route path={ROUTES.CATCH_ALL.path} element={<Navigate replace to={ROUTES.LOGIN.path} />} />
      </Routes>
    </BrowserRouter>
  );
};
export default AppRouter;
